import React, { useEffect, useState, useRef } from "react";
import apiDefinitions from "../../../api/apiDefinitions";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import { Pagination, Form, OverlayTrigger, Popover } from "react-bootstrap";
import {
  priority,
  status,
} from "../../../core/common/selectoption/selectoption";
import toast from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import FileUpload from "./fileUploader";
import { set } from "date-fns";
import { Typography } from "@mui/material";
// import ImageWithBasePath from "../../..imageWithBasePath/core/common/imageWithBasePath";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";

const ViewAllStakeholders = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const hasDataLoaded = useRef(false);
  const [employeeId, setEmployeeId] = useState("");
  const [leads, setLeads] = useState<Lead[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [employeeList, setEmployeeList] = useState<any[]>([]);
  const [searchKey, setSearchKey] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [stakeholderName, setStakeholderName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [department, setDepartment] = useState("");
  const [designation, setDesignation] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [workAddress, setWorkAddress] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankBranchName, setBankBranchName] = useState("");
  const [bankBranchCode, setBankBranchCode] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [NIC, setNIC] = useState("");
  const [refresh, setRefresh] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [selectedStakeholderId, setSelectedStakeholderId] = useState<
    number | null
  >(null);

  const [isStakeholderNameValid, setIsStakeholderNameValid] = useState(false);
  const [isCompanyNameValid, setIsCompanyNameValid] = useState(false);
  const [isDesignationValid, setIsDesignationValid] = useState(false);
  const [isContactValid, setIsContactValid] = useState(false);
  const [isDepartmentValid, setIsDepartmentValid] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isWorkAddressValid, setIsWorkAddressValid] = useState(false);
  const [isBankNameValid, setIsBankNameValid] = useState(false);
  const [isBankBranchNameValid, setIsBankBranchNameValid] = useState(false);
  const [isBankAccountNumberValid, setIsBankAccountNumberValid] =
    useState(false);
  const [isBankBranchCodeValid, setIsBankBranchCodeValid] = useState(false);
  const [isAccountHolderNameValid, setIsAccountHolderNameValid] =
    useState(false);
  const [isNicValid, setIsNicValid] = useState(false);

  const [clearFileUploader, setClearFileUploader] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File[]>([]);
  const [isFileUploaded, setIsFileUploaded] = useState(false);

  const [attendaceDocuments, setAttendaceDocuments] = useState<any>([]);
  const [uploadAttendaceDocuments, setUploadAttendaceDocuments] =
    useState<any>(null);

  interface DecodedToken {
    exp: number;
    [key: string]: any;
  }

  interface Lead {
    id: number;
    name: string;
    phone: number;
    email: number;
    nic: string;
    activeInactiveStatus: boolean;
  }

  interface FetchLeadsResponse {
    content: Lead[];
    totalElements: number;
    totalPages: number;
  }

  useEffect(() => {
    const fetchData = async () => {
      const token = sessionStorage.getItem("token");
      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login); // Redirect to login if no token
        return;
      }

      try {
        const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp && decodedToken.exp <= currentTime) {
          console.log("Session expired. Please log in again.");
          navigate(route.login);
          return;
        }

        if (!hasDataLoaded.current) {
          hasDataLoaded.current = true;
          return;
        }

        const offset = currentPage - 1;

        const toastId = toast.loading("Loading Data...");
        try {
          const response = await apiDefinitions.getAllStakeholders(
            token,
            searchKey,
            filterStatus,
            offset,
            itemsPerPage
          );

          if (response.data.code === 200) {
            toast.dismiss(toastId);
            toast.success("Data Loaded", { duration: 5000 });
            // const data: FetchLeadsResponse = response.data.data;
            setLeads(response.data.data.contacts);
            setTotalPages(response.data.data.totalPages);
          } else if (response.data.code === 404) {
            toast.dismiss(toastId);
            toast.error("No stakeholders Were Found", { duration: 5000 });
          } else {
            toast.dismiss(toastId);
            toast.error("Failed to fetch stakeholders. Please try again.");
          }
        } catch (error) {
          toast.dismiss(toastId);
          console.error("Failed to fetch stakeholders", error);
          toast.error("An error occurred. Please try again.");
        }
      } catch (error) {
        console.error("Invalid token or unable to decode", error);
        navigate(route.login); // Redirect if token is invalid
      }
    };

    fetchData();
  }, [currentPage, itemsPerPage, searchClicked, refresh]);

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    console.log("Current page:", currentPage);
  }, [currentPage]);

  interface ReasonPopoverProps {
    reason: string;
  }

  const renderReasonPopover = ({ reason }: ReasonPopoverProps): JSX.Element => (
    <Popover id="popover-reason">
      <Popover.Body>{reason}</Popover.Body>
    </Popover>
  );

  const handleCreateClean = () => {
    setStakeholderName("");
    setDesignation("");
    setContact("");
    setEmail("");
    setWorkAddress("");
    setCompanyName("");
    setBankName("");
    setBankAccountNumber("");
    setAccountHolderName("");
    setBankBranchName("");
    setBankBranchCode("");
    setDepartment("");
    setSelectedStakeholderId(null);
    setIsBankNameValid(false);
    setIsBankBranchNameValid(false);
    setIsBankBranchCodeValid(false);
    setIsBankAccountNumberValid(false);
    setIsAccountHolderNameValid(false);
    setIsDepartmentValid(false);
    setIsCompanyNameValid(false);
    setIsStakeholderNameValid(false);
    setIsDesignationValid(false);
    setIsContactValid(false);
    setIsEmailValid(false);
    setIsWorkAddressValid(false);
    setClearFileUploader(true);
    setNIC("");
    setIsNicValid(false);
    setUploadedFile([]);
    setAttendaceDocuments([]);
  };

  useEffect(() => {
    if (clearFileUploader) {
      setClearFileUploader(false);
    }
  }, [clearFileUploader]);

  const handleCreate = () => {
    let isvalid = true;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (stakeholderName === "") {
      isvalid = false;
      setIsStakeholderNameValid(true);
    } else {
      setIsStakeholderNameValid(false);
    }

    if (companyName === "") {
      isvalid = false;
      setIsCompanyNameValid(true);
    } else {
      setIsCompanyNameValid(false);
    }

    if (designation === "") {
      isvalid = false;
      setIsDesignationValid(true);
    } else {
      setIsDesignationValid(false);
    }

    if (!contact || contact.length !== 10) {
      isvalid = false;
      setIsContactValid(true);
    } else {
      setIsContactValid(false);
    }

    if (!email || !emailRegex.test(email)) {
      isvalid = false;
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
    }

    if (workAddress === "") {
      isvalid = false;
      setIsWorkAddressValid(true);
    } else {
      setIsWorkAddressValid(false);
    }

    if (bankName === "") {
      isvalid = false;
      setIsBankNameValid(true);
    } else {
      setIsBankNameValid(false);
    }

    if (bankBranchName === "") {
      isvalid = false;
      setIsBankBranchNameValid(true);
    } else {
      setIsBankBranchNameValid(false);
    }

    if (bankBranchCode === "") {
      isvalid = false;
      setIsBankBranchCodeValid(true);
    } else {
      setIsBankBranchCodeValid(false);
    }

    if (bankAccountNumber === "") {
      isvalid = false;
      setIsBankAccountNumberValid(true);
    } else {
      setIsBankAccountNumberValid(false);
    }

    if (accountHolderName === "") {
      isvalid = false;
      setIsAccountHolderNameValid(true);
    } else {
      setIsAccountHolderNameValid(false);
    }

    if (department === "") {
      isvalid = false;
      setIsDepartmentValid(true);
    } else {
      setIsDepartmentValid(false);
    }

    if (NIC === "") {
      isvalid = false;
      setIsNicValid(true);
    } else {
      setIsNicValid(false);
    }

    if (uploadedFile.length === 0) {
      isvalid = false;
      setIsFileUploaded(true);
    } else {
      setIsFileUploaded(false);
    }

    if (isvalid) {
      const formData = new FormData();

      if (uploadedFile && uploadedFile.length > 0) {
        uploadedFile.forEach((file) => {
          formData.append("files", file);
        });
      }

      const payload = {
        name: stakeholderName,
        email: email,
        phone: contact,
        department: department,
        position: designation,
        address: workAddress,
        companyName: companyName,
        bankName: bankName,
        bankAccountNumber: bankAccountNumber,
        accountHolderName: accountHolderName,
        bankBranch: bankBranchName,
        bankBranchCode: bankBranchCode,
        nic: NIC,
      };

      formData.append("createContactDto", JSON.stringify(payload));

      formData.forEach((value, key) => {
        console.log(key, value);
      });

      Swal.fire({
        title: "Do You Want To Add The Beneficiary?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes, Add This Beneficiary",
        denyButtonText: `No, Cancel`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }

          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Adding Beneficiary...");
              // Token is valid, proceed with the API call

              const response = await apiDefinitions.createStakeholder(
                token,
                employeeId,
                formData
              );

              if (response.data.code === 201) {
                toast.dismiss(toastId);
                console.log("Response", response.data.data);
                handleCreateClean();
                window.location.reload();
                toast.success("Beneficiary Created Successfully", {
                  duration: 5000,
                });
              } else if (response.data.code === 409) {
                toast.dismiss(toastId);
                toast.error("Email Already Exists");
              } else {
                toast.dismiss(toastId);
                toast.error("Failed to Create Beneficiary");
              }
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        } else {
          toast("Cancelled", {
            icon: "⚠️",
          });
        }
      });
    } else {
      console.error(
        "Form validation failed. Please check the form for errors."
      );
    }
  };

  const handleUpdate = () => {
    let isvalid = true;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (stakeholderName === "") {
      isvalid = false;
      setIsStakeholderNameValid(true);
    } else {
      setIsStakeholderNameValid(false);
    }

    if (companyName === "") {
      isvalid = false;
      setIsCompanyNameValid(true);
    } else {
      setIsCompanyNameValid(false);
    }

    if (designation === "") {
      isvalid = false;
      setIsDesignationValid(true);
    } else {
      setIsDesignationValid(false);
    }

    if (!contact || contact.length !== 10) {
      isvalid = false;
      setIsContactValid(true);
    } else {
      setIsContactValid(false);
    }

    if (!email || !emailRegex.test(email)) {
      isvalid = false;
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
    }

    if (workAddress === "") {
      isvalid = false;
      setIsWorkAddressValid(true);
    } else {
      setIsWorkAddressValid(false);
    }

    if (bankName === "") {
      isvalid = false;
      setIsBankNameValid(true);
    } else {
      setIsBankNameValid(false);
    }

    if (bankBranchName === "") {
      isvalid = false;
      setIsBankBranchNameValid(true);
    } else {
      setIsBankBranchNameValid(false);
    }

    if (bankBranchCode === "") {
      isvalid = false;
      setIsBankBranchCodeValid(true);
    } else {
      setIsBankBranchCodeValid(false);
    }

    if (bankAccountNumber === "") {
      isvalid = false;
      setIsBankAccountNumberValid(true);
    } else {
      setIsBankAccountNumberValid(false);
    }

    if (accountHolderName === "") {
      isvalid = false;
      setIsAccountHolderNameValid(true);
    } else {
      setIsAccountHolderNameValid(false);
    }

    if (department === "") {
      isvalid = false;
      setIsDepartmentValid(true);
    } else {
      setIsDepartmentValid(false);
    }

    if (NIC === "") {
      isvalid = false;
      setIsNicValid(true);
    } else {
      setIsNicValid(false);
    }

    // if (uploadedFile.length === 0) {
    //   isvalid = false;
    //   setIsFileUploaded(true);
    // } else {
    //   setIsFileUploaded(false);
    // }

    if (isvalid) {
      const formDataUpdate = new FormData();

      if (uploadedFile && uploadedFile.length > 0) {
        uploadedFile.forEach((file) => {
          formDataUpdate.append("files", file);
        });
      }

      const payload = {
        name: stakeholderName,
        email: email,
        phone: contact,
        department: department,
        position: designation,
        address: workAddress,
        companyName: companyName,
        bankName: bankName,
        bankAccountNumber: bankAccountNumber,
        accountHolderName: accountHolderName,
        bankBranch: bankBranchName,
        bankBranchCode: bankBranchCode,
        nic: NIC,
      };

      formDataUpdate.append("updateContactDto", JSON.stringify(payload));

      formDataUpdate.forEach((value, key) => {
        console.log(key, value);
      });

      Swal.fire({
        title: "Do You Want To Update The Stakeholder?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes, Update Stakeholder",
        denyButtonText: `No, Cancel`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }

          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Updating Stakeholder...");
              // Token is valid, proceed with the API call

              const response = await apiDefinitions.updateStakeholder(
                token,
                selectedStakeholderId,
                employeeId,
                formDataUpdate
              );

              if (response.data.code === 200) {
                toast.dismiss(toastId);
                console.log("Response", response.data.data);
                handleCreateClean();
                window.location.reload();
                toast.success("Stakeholder Updated Successfully", {
                  duration: 5000,
                });
              } else {
                toast.dismiss(toastId);
                toast.error("Failed to Update Stakeholder");
              }
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        } else {
          toast("Cancelled", {
            icon: "⚠️",
          });
        }
      });
    } else {
      console.error(
        "Form validation failed. Please check the form for errors."
      );
    }
  };

  interface Option {
    value: number;
    label: string;
  }

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      console.log("Decoded Token", decodedToken);

      setEmployeeId(decodedToken.serial_number);
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getMarketingEmployeeList(token).then((response: any) => {
          console.log("Course Categories: ", response.data.data);
          setEmployeeList(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  const handleSearch = () => {
    setSearchClicked(!searchClicked);
  };

  const handleSearchClose = () => {
    setSearchClicked(!searchClicked);
    setSearchKey("");
  };

  const handleActiveStatus = (id: number, activeInactiveStatus: boolean) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    const status = !activeInactiveStatus;

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const loadingToastId = toast.loading("Changing Status...");
        apiDefinitions
          .stakeholderStatus(token, id, status, employeeId)
          .then((response: any) => {
            if (response.data.code === 200) {
              toast.dismiss(loadingToastId);
              setRefresh(!refresh);
              toast.success("Status Changed Successfully");
            } else {
              toast.dismiss(loadingToastId);
              toast.error("Failed to Change Status");
            }
          });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  const handleGetStakeholder = (id: number) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const loadingToastId = toast.loading("Fetching Details...");
        apiDefinitions.getStakeholderById(token, id).then((response: any) => {
          if (response.data.code === 200) {
            toast.dismiss(loadingToastId);
            toast.success("Details Loaded Successfully");
            setStakeholderName(response.data.data.name);
            setDesignation(response.data.data.position);
            setCompanyName(response.data.data.companyName);
            setDepartment(response.data.data.department);
            setContact(response.data.data.phone);
            setEmail(response.data.data.email);
            setWorkAddress(response.data.data.address);
            setSelectedStakeholderId(id);
            setBankName(response.data.data.bankDetails[0].bankName);
            setBankAccountNumber(
              response.data.data.bankDetails[0].bankAccountNumber
            );
            setAccountHolderName(
              response.data.data.bankDetails[0].accountHolderName
            );
            setBankBranchName(response.data.data.bankDetails[0].bankBranch);
            setBankBranchCode(response.data.data.bankDetails[0].bankBranchCode);
            setUploadAttendaceDocuments(
              response.data.data.contactFileJustifications
            );
            setNIC(response.data.data.nic);
            console.log(
              "Response",
              response.data.data.contactFileJustifications[0]
            );
          } else {
            toast.dismiss(loadingToastId);
            toast.error("Failed to Load Details");
          }
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  const handleFileSelect = (files: any) => {
    setUploadedFile(files);
  };

  useEffect(() => {
    if (uploadAttendaceDocuments !== null) {
      const transformedData = uploadAttendaceDocuments.map(
        (url: string, index: number) => {
          const filePath = url || "";
          const decodedFilePath = decodeURIComponent(filePath); // Decode URL-encoded characters
          const fileName = decodedFilePath.split("/").pop() || "";
          const fileExtension = filePath.split(".").pop()?.toLowerCase() || "";

          let fileType = "unknown";

          if (fileExtension === "pdf") {
            fileType = "pdf";
          } else if (fileExtension.match(/(jpg|jpeg|png|gif|bmp|svg|webp)$/)) {
            fileType = "image";
          } else if (fileExtension.match(/(doc|docx)$/)) {
            fileType = "doc";
          } else if (fileExtension.match(/(xls|xlsx)$/)) {
            fileType = "xls";
          }

          return {
            id: index, // Use index as a unique identifier
            filePath: filePath,
            fileName: fileName,
            fileType: fileType,
            fileExtension: fileExtension,
          };
        }
      );

      setAttendaceDocuments(transformedData);
    } else {
      // Handle the case where uploadAttendaceDocuments is null
      // You might want to set some default value or handle it based on your requirements
      setAttendaceDocuments([]);
    }
  }, [uploadAttendaceDocuments]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">View Beneficiaries</div>
                  <div className="row">
                    <div className="col-md-1 mb-3 mt-3">
                      <Form.Select
                        value={itemsPerPage}
                        onChange={(event) =>
                          setItemsPerPage(parseInt(event.target.value, 10))
                        }
                        aria-label="Select number of items per page"
                        className="w-auto"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </Form.Select>
                    </div>

                    <div className="col-md-4 mt-3">
                      <input
                        type="text"
                        className="form-control"
                        id="validationCustom01"
                        placeholder="Search"
                        value={searchKey}
                        onChange={(e) => setSearchKey(e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-md-3 mt-3">
                      <select
                        className={`form-select`}
                        id="validationCustomContactMethod"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Select a status
                        </option>
                        <option value="true">Active </option>
                        <option value="false">Inactive</option>
                      </select>
                    </div>

                    <div
                      className="col-md-1 mt-3"
                      style={{ textAlign: "start" }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={
                          searchClicked ? handleSearchClose : handleSearch
                        }
                      >
                        <i
                          className={`fas ${
                            searchClicked ? "fa-times" : "fa-search"
                          }`}
                          style={{
                            marginRight: "5px",
                            padding: "4px",
                            fontSize: "15px",
                            marginLeft: "1px",
                          }}
                        ></i>
                      </button>
                    </div>

                    <div
                      className="col-md-12 mt-3"
                      style={{ textAlign: "start" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light mt-1 me-1"
                        data-bs-toggle="modal"
                        data-bs-target="#lead-export-modal"
                      >
                        <i
                          className="fas fa-plus"
                          style={{
                            marginRight: "5px",
                            padding: "4px",
                            fontSize: "15px",
                            marginLeft: "1px",
                          }}
                        ></i>{" "}
                        Add Beneficiary
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table text-nowrap table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Beneficiary's Name</th>
                          <th scope="col">Email</th>
                          <th scope="col">Contact Number</th>
                          <th scope="col">Status</th>
                          <th scope="col">Active/ Inactive Toggle</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leads.length > 0 ? (
                          leads.map((lead, index) => (
                            <tr key={index}>
                              <td>
                                {lead?.name?.length > 30 ? (
                                  <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    placement="top"
                                    overlay={renderReasonPopover({
                                      reason: lead.name,
                                    })}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      {lead.name.substring(0, 30)}...
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  lead.name
                                )}
                              </td>
                              <td>{lead.email}</td>
                              <td>{lead.phone}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    lead.activeInactiveStatus === true
                                      ? "bg-soft-success"
                                      : "bg-soft-danger"
                                  }`}
                                >
                                  {lead.activeInactiveStatus === true
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <div className="hstack gap-2 fs-15">
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={lead.activeInactiveStatus}
                                      onChange={() => {
                                        handleActiveStatus(
                                          lead.id,
                                          lead.activeInactiveStatus
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="hstack gap-2 fs-15">
                                  <button
                                    type="button"
                                    className="btn btn-success waves-effect waves-light mt-1 me-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#view-modal"
                                    onClick={() => {
                                      handleGetStakeholder(lead.id);
                                    }}
                                  >
                                    <i className="fas fa-eye"></i>{" "}
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-info waves-effect waves-light mt-1 me-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#update-modal"
                                    onClick={() => {
                                      handleGetStakeholder(lead.id);
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>{" "}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={9} className="text-center">
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination className="mt-3 justify-content-center">
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    {Array.from({ length: totalPages }, (_, index) => (
                      <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage}
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="lead-export-modal"
        tabIndex={-1}
        aria-labelledby="lead-export-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "900px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="lead-export-modal-label">
                Add Beneficiary
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCreateClean}
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Beneficiary's Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isStakeholderNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Beneficiary Name"
                    value={stakeholderName}
                    onChange={(e) => setStakeholderName(e.target.value)}
                    required
                  />
                  {isStakeholderNameValid && (
                    <div className="invalid-feedback">Please enter a name.</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Company Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isCompanyNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Company Name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                  />
                  {isCompanyNameValid && (
                    <div className="invalid-feedback">
                      Please enter a company name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Department
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isDepartmentValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Department"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    required
                  />
                  {isDepartmentValid && (
                    <div className="invalid-feedback">
                      Please enter a department.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Designation
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isDesignationValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Designation"
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                    required
                  />
                  {isDesignationValid && (
                    <div className="invalid-feedback">
                      Please enter a designation.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    NIC
                  </label>
                  <input
                    type="text"
                    className={`form-control ${isNicValid ? "is-invalid" : ""}`}
                    id="validationCustom01"
                    placeholder="NIC"
                    value={NIC}
                    onChange={(e) => setNIC(e.target.value)}
                    required
                  />
                  {isNicValid && (
                    <div className="invalid-feedback">Please enter an nic.</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isContactValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {isContactValid && (
                    <div className="invalid-feedback">
                      Please enter a valid contact.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isEmailValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Email Address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {isEmailValid && (
                    <div className="invalid-feedback">
                      Please enter a valid email.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Work Address
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isWorkAddressValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Work Address"
                    value={workAddress}
                    onChange={(e) => setWorkAddress(e.target.value)}
                    required
                  />
                  {isWorkAddressValid && (
                    <div className="invalid-feedback">
                      Please enter a work address.
                    </div>
                  )}
                </div>
              </div>

              <div className="divider"></div>

              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Name"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    required
                  />
                  {isBankNameValid && (
                    <div className="invalid-feedback">
                      Please enter a bank name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Account Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankAccountNumberValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Account Number"
                    value={bankAccountNumber}
                    onChange={(e) => setBankAccountNumber(e.target.value)}
                    required
                  />
                  {isBankAccountNumberValid && (
                    <div className="invalid-feedback">
                      Please enter a bank account number.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Account Holder Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isAccountHolderNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Account Holder Name"
                    value={accountHolderName}
                    onChange={(e) => setAccountHolderName(e.target.value)}
                    required
                  />
                  {isAccountHolderNameValid && (
                    <div className="invalid-feedback">
                      Please enter a account holder name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Branch Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankBranchNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Branch Name"
                    value={bankBranchName}
                    onChange={(e) => setBankBranchName(e.target.value)}
                    required
                  />
                  {isBankBranchNameValid && (
                    <div className="invalid-feedback">
                      Please enter a bank branch name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Branch Code
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankBranchCodeValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Branch Code"
                    value={bankBranchCode}
                    onChange={(e) => setBankBranchCode(e.target.value)}
                    required
                  />
                  {isBankBranchCodeValid && (
                    <div className="invalid-feedback">
                      Please enter a bank branch code.
                    </div>
                  )}
                </div>
              </div>

              <div className="divider"></div>

              <FileUpload
                onFileSelect={handleFileSelect}
                clear={clearFileUploader}
              />
              {isFileUploaded === true ? (
                <div className="text-danger">Please Upload a Workplace ID</div>
              ) : null}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel waves-effect"
                data-bs-dismiss="modal"
                onClick={handleCreateClean}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary waves-effect waves-light"
                onClick={handleCreate}
              >
                Add Beneficiary
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="update-modal"
        tabIndex={-1}
        aria-labelledby="lead-export-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "900px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="lead-export-modal-label">
                Update Beneficiaries
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCreateClean}
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Beneficiary's Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isStakeholderNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Beneficiary Name"
                    value={stakeholderName}
                    onChange={(e) => setStakeholderName(e.target.value)}
                    required
                  />
                  {isStakeholderNameValid && (
                    <div className="invalid-feedback">Please enter a name.</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Company Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isCompanyNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Company Name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                  />
                  {isCompanyNameValid && (
                    <div className="invalid-feedback">
                      Please enter a company name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Department
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isDepartmentValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Designation"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    required
                  />
                  {isDepartmentValid && (
                    <div className="invalid-feedback">
                      Please enter a department.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Designation
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isDesignationValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Designation"
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                    required
                  />
                  {isDesignationValid && (
                    <div className="invalid-feedback">
                      Please enter a designation.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    NIC
                  </label>
                  <input
                    type="text"
                    className={`form-control ${isNicValid ? "is-invalid" : ""}`}
                    id="validationCustom01"
                    placeholder="NIC"
                    value={NIC}
                    onChange={(e) => setNIC(e.target.value)}
                    required
                  />
                  {isNicValid && (
                    <div className="invalid-feedback">Please enter an nic.</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isContactValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {isContactValid && (
                    <div className="invalid-feedback">
                      Please enter a valid contact.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isEmailValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {isEmailValid && (
                    <div className="invalid-feedback">
                      Please enter a valid email.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Work Address
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isWorkAddressValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={workAddress}
                    onChange={(e) => setWorkAddress(e.target.value)}
                    required
                  />
                  {isWorkAddressValid && (
                    <div className="invalid-feedback">
                      Please enter a work address.
                    </div>
                  )}
                </div>
              </div>

              <div className="divider"></div>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Name"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    required
                  />
                  {isBankNameValid && (
                    <div className="invalid-feedback">
                      Please enter a bank name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Account Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankAccountNumberValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Account Number"
                    value={bankAccountNumber}
                    onChange={(e) => setBankAccountNumber(e.target.value)}
                    required
                  />
                  {isBankAccountNumberValid && (
                    <div className="invalid-feedback">
                      Please enter a bank account number.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Account Holder Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isAccountHolderNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Account Holder Name"
                    value={accountHolderName}
                    onChange={(e) => setAccountHolderName(e.target.value)}
                    required
                  />
                  {isAccountHolderNameValid && (
                    <div className="invalid-feedback">
                      Please enter a account holder name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Branch Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankBranchNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Branch Name"
                    value={bankBranchName}
                    onChange={(e) => setBankBranchName(e.target.value)}
                    required
                  />
                  {isBankBranchNameValid && (
                    <div className="invalid-feedback">
                      Please enter a bank branch name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3 mb-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Branch Code
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankBranchCodeValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Branch Code"
                    value={bankBranchCode}
                    onChange={(e) => setBankBranchCode(e.target.value)}
                    required
                  />
                  {isBankBranchCodeValid && (
                    <div className="invalid-feedback">
                      Please enter a bank branch code.
                    </div>
                  )}
                </div>

                <FileUpload
                  onFileSelect={handleFileSelect}
                  clear={clearFileUploader}
                />
                {isFileUploaded === true ? (
                  <div className="text-danger">
                    Please Upload a Workplace ID
                  </div>
                ) : null}
              </div>

              <div className="divider"></div>

              <Typography variant="subtitle1" gutterBottom>
                Workplace ID:
              </Typography>
              <div className="col-md-12">
                <div className="row">
                  {attendaceDocuments.map(
                    (data: {
                      id: React.Key | null | undefined;
                      fileType: string;
                      fileName: any;
                      filePath: string | URL | undefined;
                    }) => (
                      <div className="col-md-3 mb-5" key={data.id}>
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          {/* File Type Icon */}
                          <div className="mb-3">
                            {data.fileType === "pdf" ? (
                              <ImageWithBasePath
                                src="assets/img/pdf.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : data.fileType === "image" ? (
                              <ImageWithBasePath
                                src="assets/img/picture.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : data.fileType === "doc" ? (
                              <ImageWithBasePath
                                src="assets/img/doc.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : data.fileType === "xls" ? (
                              <ImageWithBasePath
                                src="assets/img/xls.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : null}
                          </div>
                          {/* File Details */}
                          <div className="text-center">
                            <h6
                              className="mb-2 text-truncate"
                              style={{
                                maxWidth: "150px", // Adjust width as per your layout
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                              title={data.fileName} // Show full name on hover
                            >
                              {data.fileName || "Placeholder Name"}
                            </h6>
                          </div>
                          {/* Action Buttons */}
                          <div className="d-flex justify-content-center">
                            <a
                              href={data.filePath?.toString()} // File URL
                              download={data.fileName} // Download file with its name
                              className="btn btn-outline-primary me-2 btn-sm"
                            >
                              Download File
                            </a>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel waves-effect"
                data-bs-dismiss="modal"
                onClick={handleCreateClean}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary waves-effect waves-light"
                onClick={handleUpdate}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="view-modal"
        tabIndex={-1}
        aria-labelledby="lead-export-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "900px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="lead-export-modal-label">
                View Beneficiary Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCreateClean}
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Beneficiary's Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isStakeholderNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Beneficiary Name"
                    value={stakeholderName}
                    onChange={(e) => setStakeholderName(e.target.value)}
                    required
                    disabled
                  />
                  {isStakeholderNameValid && (
                    <div className="invalid-feedback">Please enter a name.</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Company Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isCompanyNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Company Name"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    required
                    disabled
                  />
                  {isCompanyNameValid && (
                    <div className="invalid-feedback">
                      Please enter a company name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Department
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isDepartmentValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Designation"
                    value={department}
                    onChange={(e) => setDepartment(e.target.value)}
                    required
                    disabled
                  />
                  {isDepartmentValid && (
                    <div className="invalid-feedback">
                      Please enter a department.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Designation
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isDesignationValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Designation"
                    value={designation}
                    onChange={(e) => setDesignation(e.target.value)}
                    required
                    disabled
                  />
                  {isDesignationValid && (
                    <div className="invalid-feedback">
                      Please enter a designation.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    NIC
                  </label>
                  <input
                    type="text"
                    className={`form-control ${isNicValid ? "is-invalid" : ""}`}
                    id="validationCustom01"
                    placeholder="NIC"
                    value={NIC}
                    onChange={(e) => setNIC(e.target.value)}
                    required
                  />
                  {isNicValid && (
                    <div className="invalid-feedback">Please enter an nic.</div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isContactValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    required
                    disabled
                  />
                  {isContactValid && (
                    <div className="invalid-feedback">
                      Please enter a valid contact.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isEmailValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled
                  />
                  {isEmailValid && (
                    <div className="invalid-feedback">
                      Please enter a valid email.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Work Address
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isWorkAddressValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={workAddress}
                    onChange={(e) => setWorkAddress(e.target.value)}
                    required
                    disabled
                  />
                  {isWorkAddressValid && (
                    <div className="invalid-feedback">
                      Please enter a work address.
                    </div>
                  )}
                </div>
              </div>

              <div className="divider"></div>
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Name"
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)}
                    required
                    disabled
                  />
                  {isBankNameValid && (
                    <div className="invalid-feedback">
                      Please enter a bank name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Account Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankAccountNumberValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Account Number"
                    value={bankAccountNumber}
                    onChange={(e) => setBankAccountNumber(e.target.value)}
                    required
                    disabled
                  />
                  {isBankAccountNumberValid && (
                    <div className="invalid-feedback">
                      Please enter a bank account number.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Account Holder Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isAccountHolderNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Account Holder Name"
                    value={accountHolderName}
                    onChange={(e) => setAccountHolderName(e.target.value)}
                    required
                    disabled
                  />
                  {isAccountHolderNameValid && (
                    <div className="invalid-feedback">
                      Please enter a account holder name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Branch Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankBranchNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Branch Name"
                    value={bankBranchName}
                    onChange={(e) => setBankBranchName(e.target.value)}
                    required
                    disabled
                  />
                  {isBankBranchNameValid && (
                    <div className="invalid-feedback">
                      Please enter a bank branch name.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Bank Branch Code
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isBankBranchCodeValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Bank Branch Code"
                    value={bankBranchCode}
                    onChange={(e) => setBankBranchCode(e.target.value)}
                    required
                    disabled
                  />
                  {isBankBranchCodeValid && (
                    <div className="invalid-feedback">
                      Please enter a bank branch code.
                    </div>
                  )}
                </div>
              </div>

              <div className="divider"></div>

              <Typography variant="subtitle1" gutterBottom>
                Workplace ID:
              </Typography>
              <div className="col-md-12">
                <div className="row">
                  {attendaceDocuments.map(
                    (data: {
                      id: React.Key | null | undefined;
                      fileType: string;
                      fileName: any;
                      filePath: string | URL | undefined;
                    }) => (
                      <div className="col-md-3 mb-5" key={data.id}>
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          {/* File Type Icon */}
                          <div className="mb-3">
                            {data.fileType === "pdf" ? (
                              <ImageWithBasePath
                                src="assets/img/pdf.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : data.fileType === "image" ? (
                              <ImageWithBasePath
                                src="assets/img/picture.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : data.fileType === "doc" ? (
                              <ImageWithBasePath
                                src="assets/img/doc.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : data.fileType === "xls" ? (
                              <ImageWithBasePath
                                src="assets/img/xls.png"
                                className="img-fluid"
                                alt="Logo"
                                style={{ width: "35px", height: "auto" }} // Adjust the width and height as needed
                              />
                            ) : null}
                          </div>
                          {/* File Details */}
                          <div className="text-center">
                            <h6
                              className="mb-2 text-truncate"
                              style={{
                                maxWidth: "150px", // Adjust width as per your layout
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                              title={data.fileName} // Show full name on hover
                            >
                              {data.fileName || "Placeholder Name"}
                            </h6>
                          </div>
                          {/* Action Buttons */}
                          <div className="d-flex justify-content-center">
                            <a
                              href={data.filePath?.toString()} // File URL
                              download={data.fileName} // Download file with its name
                              className="btn btn-outline-primary me-2 btn-sm"
                            >
                              Download File
                            </a>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel waves-effect"
                data-bs-dismiss="modal"
                onClick={handleCreateClean}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllStakeholders;
